import React from 'react';
import { Table, Message } from 'semantic-ui-react';
import Moment from 'moment';
import _ from 'underscore';

const HradminEmployeeDetailsTable = (props) => {
    const {
        name,
        birthdate,
        contactNoCountryCode,
        contactNo,
        lastLogin,
        status,
        gender,
        designation,
        planNo,
        staffId,
        costCenter,
        maritalStatus,
        nationality,
        nric,
        email,
        family
    } = props.employee;
    return (
        <Table fixed>
            <Table.Body>
                <Table.Row>
                    <Table.Cell colSpan={4} textAlign="center">
                        <b>Information</b>
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Name
                    </Table.Cell>
                    <Table.Cell>
                        {name}
                    </Table.Cell>
                    <Table.Cell>
                        BirthDate
                    </Table.Cell>
                    <Table.Cell>
                        {(birthdate) ? Moment(birthdate).format('DD-MM-YYYY') : ''}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Contact Number
                    </Table.Cell>
                    <Table.Cell>
                        {`+${contactNoCountryCode} ${contactNo}`}
                    </Table.Cell>
                    <Table.Cell>
                        Last Login
                    </Table.Cell>
                    <Table.Cell>
                        {(lastLogin) ? Moment(lastLogin).format('DD-MM-YYYY hh:mm:ss') : ''}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Status
                    </Table.Cell>
                    <Table.Cell>
                        {status}
                    </Table.Cell>
                    <Table.Cell>
                        Gender
                    </Table.Cell>
                    <Table.Cell>
                        {gender}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Designation
                    </Table.Cell>
                    <Table.Cell>
                        {designation}
                    </Table.Cell>
                    <Table.Cell>
                        Plan No
                    </Table.Cell>
                    <Table.Cell>
                        {planNo}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Staff ID
                    </Table.Cell>
                    <Table.Cell>
                        {staffId}
                    </Table.Cell>
                    <Table.Cell>
                        Cost Center
                    </Table.Cell>
                    <Table.Cell>
                        {costCenter}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        Marital Status
                    </Table.Cell>
                    <Table.Cell>
                        {maritalStatus}
                    </Table.Cell>
                    <Table.Cell>
                        Nationality
                    </Table.Cell>
                    <Table.Cell>
                        {nationality}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell>
                        NRIC
                    </Table.Cell>
                    <Table.Cell>
                        {nric}
                    </Table.Cell>
                    <Table.Cell>
                        Email
                    </Table.Cell>
                    <Table.Cell>
                        {email}
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell colSpan={4} textAlign="center">
                        <b>Dependents / Family</b>
                    </Table.Cell>
                </Table.Row>
                {
                    _.map(family, (dependent, index) => {
                        return (
                            <Table.Row key={index}>
                                <Table.Cell>Name</Table.Cell>
                                <Table.Cell>{dependent.name}</Table.Cell>
                                <Table.Cell>NRIC</Table.Cell>
                                <Table.Cell>{dependent.nric}</Table.Cell>
                            </Table.Row>
                        );
                    })
                }
                {
                    (family.length === 0) ?
                    (
                        <Table.Row>
                            <Table.Cell colSpan={4} textAlign="center">
                                <Message info>
                                    There are no dependents attached to this employee.
                                </Message>
                            </Table.Cell>
                        </Table.Row>
                    )
                    : null
                }
            </Table.Body>
        </Table>
    );
}

export default HradminEmployeeDetailsTable;